/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  app.PaymentPrepareView = app.FormView.extend({
    templateName: '#payment-prepare-template',
    events: {
      'click .js-payment-button': 'validateOrder'
    },
    run: function () {
      this.template = app.helpers.TemplateHelper.getTemplate(this.templateName);
    },
    validateOrder: function (e) {
      e.preventDefault();
      var that = this,
        targetId = $(e.currentTarget).data('id'),
        targetHash = $(e.currentTarget).data('hash'),
        buttonGroup = $(e.currentTarget).parent('.button-group'),
        secret = app.helpers.UrlHelper.getUrlParameter('secret'),
        url = app.entryScriptName + '/api/v3/payment/' + targetId + '/';
      if (secret) {
        url += '?secret=' + secret;
      }
      that.$('.js-payment-button').attr('disabled', true);
      $.ajax({
        url: url,
        method: 'PUT',
        data: {
          hash: targetHash
        }
      }).done(function (data) {
        buttonGroup.removeClass('with-error');
        if (data['ORDER']) {
          that.renderFormAndSubmit(data);
        } else if (data.url) {
          app.helpers.RedirectHelper.locationAssign(data.url);
        }
        that.$('#error-' + targetId).text('');
      }).fail(function (error) {
        buttonGroup.addClass('with-error');
        if (error.status === 422) {
          that.$('#error-' + targetId).text(error.responseJSON[0].message);
        } else {
          that.$('#error-' + targetId).text('Что-то пошло не так. Пожалуйста, перезагрузите страницу');
          if (typeof Raven !== 'undefined' && typeof Raven.captureException === 'function') {
            Raven.captureException(new Error('Ошибка при переходе на страницу оплаты'), {
              extra: {
                url: url,
                method: 'PUT',
                data: {
                  hash: targetHash
                }
              }
            });
          }
        }
      });
    },
    renderFormAndSubmit: function (data) {
      this.$('.form-container').html(this.template({data: data}));
      this.$('.hidden-form').submit();
    }
  });
})();

}.call(window));